export const getSessionToken = () => {
  const parts = window.location.pathname.split("/");
  return parts[1].split("?")[0];
};
